import {EquityWizardData} from "../models/EquityWizardData";
import {OrderPlaceConditions, PlaceOrderRequest} from "../../services/models/PlaceOrderRequest";
import {OrderSide} from "../../../../../orders/models/OrderRecord";
import {DateTimeUtil} from "../../../../../js/util/DateTimeUtil";
import {Optional} from "../../../../../js/util/Optional";
import {Equality} from "../../../../../types/GenericTypes";
import {Condition, PriceBase} from "../../../../../orders/models/OrderConditions";

export interface EquityOrderRequest {
    readonly portfolioId: number;
    readonly order: PlaceOrderRequest;
}

export function extractOrderRequest(data: EquityWizardData): EquityOrderRequest | null {
    if (data.portfolio == null) {
        return null;
    } else {
        const order = buildOrderRequest(data);
        return {
            portfolioId: data.portfolio?.id,
            order
        };
    }
}

export function buildOrderRequest(data: EquityWizardData): PlaceOrderRequest {
    const expires = Optional.of(data)
                            .map((d) => d.expiry)
                            .map((d) => DateTimeUtil.dateToIso(d))
                            .orNull();
    const conditions = orderConditions(data);
    return {
        code: data.code!,
        exchange: data.exchange,
        description: "",
        buy: data.side === OrderSide.BUY,
        quantity: data.quantity,
        limit: data.limit!,
        pricingInstruction: data.pricingInstruction,
        lifetime: data.lifetime,
        expires,
        legs: [],
        tmcOverride: false,
        advice: data.advice,
        conditions,
        childOrders: data.childOrders,
        isParentOrder: data.isParentOrder
    };
}

function orderConditions(data: EquityWizardData): OrderPlaceConditions | null {
    if (data.isStopLoss && data.stopLossLimit != null) {
        return {
            priceBase: PriceBase.LAST,
            condition: Condition.LESS_OR_EQUAL,
            price: data.stopLossLimit!
        };
    } else {
        return null;
    }
}

/* Checks if the values required for a brokerage request have changed */
export function isSameBrokerageRequest(): Equality<EquityOrderRequest> {
    return (a, b) => (a.portfolioId === b.portfolioId) &&
        (a.order.code === b.order.code) &&
        (a.order.exchange === b.order.exchange) &&
        (a.order.buy === b.order.buy) &&
        (a.order.quantity === b.order.quantity) &&
        (a.order.pricingInstruction === b.order.pricingInstruction) &&
        (a.order.limit === b.order.limit);
}
